import React from 'react';

import { Dialog, DialogTitle } from '@mui/material';
import * as z from 'zod';

import CreateProjectForm from './CreateProjectForm';

const CreateProjectSchema = z.object({
  name: z.string().trim().trim().min(1, 'Project name is required'),
  description: z.string().trim().optional(),
});

type CreateProjectSchemaType = z.infer<typeof CreateProjectSchema>;

type CreateProjectDialogProps = {
  open: boolean;
  handleClose: () => void;
  trigger?: {
    className?: React.HTMLAttributes<HTMLButtonElement>['className'];
    label: React.ReactNode;
  };
  defaultValues?: CreateProjectSchemaType & {
    id: number;
  };
  primaryActionLabel?: string;
};

const CreateProjectDialog = ({
  defaultValues,
  trigger,
  open,
  handleClose,
  primaryActionLabel,
}: CreateProjectDialogProps) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSetIsLoading = (loading: boolean) => {
    setIsLoading(loading);
  };

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {defaultValues
          ? `Edit ${defaultValues.name} Project`
          : 'Create A New Project'}
      </DialogTitle>
      <CreateProjectForm
        handleOnCancel={handleClose}
        handleOnLoading={handleSetIsLoading}
        handleOnSubmit={handleClose}
        defaultValues={defaultValues}
        primaryActionLabel={primaryActionLabel}
      />
    </Dialog>
  );
};

export default CreateProjectDialog;
